import React from 'react';
import { TouchableWithoutFeedback } from 'react-native';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MaterialIcon from 'react-native-vector-icons/MaterialIcons';
import { IconButton } from '@material-ui/core';

import { useColors } from '../../contexts/theme';


const styles = {
  wrapper: { paddingRight: 10 },
  link: { textDecoration: 'none', color: 'inherit' },
};

const LinkRemovalRegexp = /(http|https):\/\//gi;

const Action = React.forwardRef(({ action, handleClose }, ref) => {
  const onClick = () => handleClose(action.url);

  return (
    <a
      ref={ref}
      accessibilityrole='link'
      accessible={true.toString()}
      target='_blank'
      rel='noreferrer noopener'
      style={styles.link}
      href={action.url}
      key={action.url}
    >
      <MenuItem
        onClick={onClick}
      >
        { action.url.replace(LinkRemovalRegexp, '') }
      </MenuItem>
    </a>
  );
});

export default function SimpleMenu({ actions }) {
  const colors = useColors(),
        [anchorEl, setAnchorEl] = React.useState(null);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <div style={styles.wrapper}>
      <IconButton
        aria-controls='simple-menu'
        aria-haspopup='true'
        onClick={handleClick}
      >
        <MaterialIcon
          name='more-vert'
          color={colors.secondary}
          size={30}
        />
      </IconButton>
      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        { actions.map((action) => (
          <Action
            key={action.url}
            action={action}
            handleClose={handleClose}
          />
        )) }
      </Menu>
    </div>
  );
}
